import Vue from 'vue';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import App from './App.vue';
import VueGtag from 'vue-gtag';
import router from './router';
import axios from 'axios';
import '@/assets/scss/main.scss';
import * as VueGoogleMaps from 'vue2-google-maps';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import store from './store';

Vue.use(VueGtag, {
  config: { id: 'G-43F1KLDM41' },
  enabled: process.env.NODE_ENV === 'production',
});

Vue.use(VueReCaptcha, { siteKey: '6Lc6EU4aAAAAABILMFHiv7-Swbm8ATJ1zKUP0W9c' });

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDrzQLJD7gk7JRlCAmPDDxS6uJC3H1GvkU',
  },
});

Vue.config.productionTip = false;
Vue.use(Buefy);

Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
